module.exports = __webpack_public_path__ + "img/pexels-adriaan-greyling-751820.fe265726.jpg";